export const buildProjectRow = (
    raw: any,
    source: any,
    overrideId: any,
    simFlag?: boolean
) => {
    return {
        start: source?.start_date || raw?.start_date || null,
        end: source?.end_date || raw?.end_date || null,
        adj_start_date: source?.adj_working_start_date || raw?.adj_working_start_date || null,
        adj_end_date: source?.end_date || raw?.end_date || null,
        id: raw?.id || overrideId,
        name: raw?.name || '',
        sim_flag: !!simFlag,
        description: null,
        progress: typeof source?.progress === 'number' ? source.progress : (raw?.progress || 0),
        type: 'project',
        hideChildren: false,
        displayOrder: 1,
        project: null,
        dependencies: null,
        inCriticalPath: null,
        responsible: null,
        start_day: 0,
        end_day: 0,
        skill_color: null,
        skill: null,
        skill_id: 0,
        member: {
            id: null,
            name: null,
            skills: null,
            tasks: null,
            busy: null,
            image_url: null
        },
        isDeleted: false,
        isUpdated: false,
        bid_price: 0,
        billing_price: 0,
        resource_price: 0,
        loss_price: 0,
        duration: source?.duration ?? null,
        delayed_duration: 0,
        additional_resources: [],
        holiday_count: 0,
        float_start_date: source?.start_date || raw?.start_date || null,
        integration_data: raw?.integration_data || null,
        status: raw?.status || source?.status || null,
        due_date: null
    } as any;
};

export const mapTasksWithOverlay = (raw: any, simFlag?: boolean) => {
    const liveTasksArr = Array.isArray(raw?.tasks) ? raw.tasks : [];
    const simTasksArr = Array.isArray(raw?.sim_data?.tasks) ? raw.sim_data.tasks : [];
    const liveById = new Map(liveTasksArr.map((t: any) => [t?.id, t]));
    const tasksFromApi = simFlag
        ? simTasksArr.map((t: any) => {
            const live: any = liveById.get(t?.id);
            const isNew = !live;
            const isUpdated = !!(t?.isUpdated);
            return {
                ...t,
                sim_flag: isNew || !!t?.sim_flag,
                isUpdated,
                live_start: live?.start,
                live_end: live?.end,
            };
        })
        : liveTasksArr;
    return tasksFromApi.map((t: any) => ({
        ...t,
        adj_start_date: t?.adj_working_start_date ?? t?.adj_start_date,
    }));
};

export const mapTasksSimple = (raw: any, simFlag?: boolean) => {
    const base = simFlag ? (raw?.sim_data?.tasks || []) : (raw?.tasks || []);
    return base.map((t: any) => ({
        ...t,
        adj_start_date: t?.adj_working_start_date ?? t?.adj_start_date,
    }));
};

export const buildNormalized = (
    raw: any,
    source: any,
    projectRow: any,
    tasksFromApi: any[]
) => {
    return {
        Results: [projectRow, ...tasksFromApi],
        skills_required: source?.skills_required || raw?.skills_required || {},
        duration: source?.duration ?? raw?.duration ?? '',
        duration_with_working_days: source?.duration_with_working_days ?? raw?.duration_with_working_days ?? '',
        duration_with_delay: source?.duration_with_delay ?? raw?.duration_with_delay ?? '',
        project_cost: raw?.project_cost || undefined,
        project_costs: source?.project_costs || raw?.project_costs || {},
        integration_data: source.integration_data || raw?.integration_data || null,
        CPLI: raw?.CPLI || undefined,
        start_date: source?.start_date || raw?.start_date || '',
        end_date: source?.end_date || raw?.end_date || '',
        durations: raw?.durations || (source?.duration ? [source.duration] : []),
        members_data: raw?.members_data || {},
        is_sim_pending: raw?.is_sim_pending ?? false,
        skill_capacity_percent: source?.skill_capacity_percent || raw?.skill_capacity_percent || {},
        skill_members: source?.skill_members || raw?.skill_members || {},
        show_simulation: raw?.show_simulation ?? true,
        share_link: raw?.share_link ?? false,
        taskAllocated: raw?.taskAllocated || {},
        org_holidays: raw?.org_holidays || [],
        stats: source?.stats || raw?.stats || {},
        status: raw?.status || source?.status || '',
        child_entity_types: raw?.child_entity_types || (raw?.child_entity_type ? {[raw.child_entity_type]: 0} : { 'task': 0 }),
        entity_type: raw?.entity_type || 'Work Units',
        progress: typeof source?.progress === 'number' ? source.progress : (raw?.progress ?? 0),
        sim_data: source?.sim_data || raw?.sim_data || {},
        resources_used_in_tasks: source?.resources_used_in_tasks || raw?.resources_used_in_tasks || {}
    } as any;
};


